import { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCommonCMSConfig } from '~api'
import { Routes } from '~constants/routes'
import useDefaultHandleBack from '~hooks/useDefaultHandleBack'

interface Props {
    backFunction?: () => void
}

const getIsBuyUrl = () => {
    return window.location.pathname.indexOf(`${Routes.buy}`) !== -1
}

/**
 * Custom handle back сделан для buy flow.
 * Проблема: в случае если открывается iframe, в историю бразуера дописываются несколько новых /app/buy записей.
 * Чтобы юзера перенести на предыдущую страницу необходимо несколько раз использовать navigate(-1)
 */
export const useCustomHandleBack = (params?: Props) => {
    const { hideMarketPage } = useCommonCMSConfig()?.data?.features || {}
    const navigate = useNavigate()
    const { backFunction } = params || {}
    const defaultHandleBack = useDefaultHandleBack()
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current)
    }, [])

    return () => {
        if (backFunction) {
            backFunction()
            return
        }

        defaultHandleBack()

        let count = 0
        const timeout = () => {
            timeoutRef.current = setTimeout(() => {
                if (getIsBuyUrl()) {
                    if (count < 5) {
                        defaultHandleBack()
                        count++
                        timeout()
                        return
                    }
                    const redirectPage = hideMarketPage ? Routes.wallet : Routes.market

                    navigate(`/${redirectPage}`)
                }
            }, 100)
        }

        timeout()
    }
}
